import request from '@/CommonDP/utils/request';
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";
export default {
// 左侧根据企业获取工作空间树
  getTree(enterpriseId) {
    return request.get(`/workSpaceManager/getTree?enterpriseId=${enterpriseId}`);
  },
  // 左侧创建树(产品配置/工作空间/工作集)
  createTree(params) {
    return request.post(`/workSpaceManager/createTree`, params);
  },
  // 左侧修改树(产品配置/工作空间/工作集)
  updateTree(params) {
    return request.post(`/workSpaceManager/updateById`, params);
  },
  // 左侧删除树(产品配置/工作空间/工作集)
  deleteTree(params) {
    return request.post(`/workSpaceManager/deleteById`, params);
  },
  // 右侧重命名
  reName(params) {
    return request.post(`/workSpaceManager/rename`, params);
  },
  // 右侧删除
  deleteRowData(params) {
    return request.post(`/workSpaceManager/deleteRight`, params);
  },
  // 根据企业id返回工作空间相关id,模拟PrjId
  getWorkSpaceDocByEnterpriseId(enterpriseId) {
    return request.get(`/workSpaceManager/getWorkSpaceDocByEnterpriseId?enterpriseId=${enterpriseId}`);
  },
  getRightList(params) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/doc/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, params);
    }
    return request.post("/doc/list", params);
  }
};
